/**
 * `Relation360_Advs` come "cartella" (tab) nel dettaglio di un record 360, sulla falsariga di
 * "Prodotti 360": elenco in sola lettura, l'unica azione è "Imposta Stato" (serve a pubblicare
 * l'ADV). I collegamenti si gestiscono dal dialogo "Dati e relazioni".
 */

import React from 'react';
import gql from 'graphql-tag';
import { StatusSetter } from './StatusSetter';
import { setAdvStatusMutation } from '../graphql/mutations/setAdvStatusMutation';
import advTypeIntro from '../static/introspection/Adv.json';
import Status360Introspection from '../static/introspection/Status360.json';
import { ENTITY } from '../utils/entities';
import { refactorInfo } from '../utils/form';

const statuses = Status360Introspection.enumValues.map((o) => o.name);

const ADV_FRAGMENT = gql`
	fragment Fragment on Adv {
		id
		localId
		title
		type
		status
	}
`;

/** Trasformatore del campo `Relation360_Advs`; `tab` è l'indice della cartella nel dettaglio. */
export const relation360AdvsTab = (tab: number) => (f: any) => {
	if (f.type !== 'EntityList') {
		refactorInfo(f, 'EntityList');
		return f;
	}
	f.tab = tab;
	f.props.headers = ['title', 'type', 'status'];
	f.props.denyAdd = true;
	f.props.hideDetailAction = true;
	f.props.fragment = ADV_FRAGMENT;
	f.props.customFields = [
		{
			header: 'setStatus',
			field: (adv: any) => ({
				name: 'setStatus',
				type: 'Custom',
				value: (
					<StatusSetter
						statuses={statuses}
						entityName={ENTITY.ADV}
						entity={adv}
						statusFieldName="status"
						mutation={setAdvStatusMutation}
						entityIntrospection={advTypeIntro}
					/>
				),
			}),
		},
	];
	return f;
};
